export const menu = [
  // {
  //   value: "/",
  //   label: "Home"
  // },
  {
    value: "/services",
    label: "Services",
    children: [
      {
        label: "Prospective International Student",
        value: "/prospective-international-student"
      },
      {
        label: "Current International Student",
        value: "/current-international-student"
      },
    ]
  },
  {
    value: "/resources",
    label: "Resources"
  },
  {
    value: "/events",
    label: "Events"
  },
  {
    value: "/our-story",
    label: "Our Story"
  },
  {
    value: "/contact",
    label: "Contact"
  }
];
